/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Stack from "../ui/Stack";
import Button from "../ui/Button";
import Text from "../ui/Text";
import Icon from "../ui/Icon";
import { ROUTES } from "../../constants/constants";

const Wrapper = styled(Stack)`
  width: 100%;
  max-width: 295px;
  margin: 0 auto;
  text-align: center;
`;

const ClientPromotionsEmptyState = () => {
  const navigate = useNavigate();
  return (
    <Wrapper $gap="1.5rem" $align="center">
      <Icon.Gift size={Icon.SIZE.XL} color="primary" strokeWidth={3}/>
      <Text color="dark">You don't have any gift cards yet</Text>
      <Button
        variant="primary"
        fullWidth
        onClick={() => navigate(ROUTES.PROMOTIONS)}
        title="Explore gift cards"
      />
    </Wrapper>
  );
};

export default ClientPromotionsEmptyState;
